import DeviceDetector from "device-detector-js";

export default function deviceInfo() {
    const deviceDetector = new DeviceDetector();
    const device = deviceDetector.parse(navigator.userAgent);
    const obj = {
        name: device.client?.name,
        os: device.os?.name,
        platform: device.device?.type,
        version: device.client?.version
    }
    return obj;
}
